import { LayoutComponent } from '../layout/layout.component';
import { OrderconfirmationComponent } from './user/orderconfirmation/orderconfirmation.component';
import { LoginComponent } from './user/login/login.component';
import { SignupComponent } from './user/signup/signup.component';
import { LockComponent } from './user/lock/lock.component';
import { RecoverComponent } from './user/recover/recover.component';
import { AuthGuard } from '../guards/auth.guard';
import {AdminGuard} from '../guards/admin.guard';
import {DealersGuard} from '../guards/dealers.guard';


export const routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    component: LayoutComponent,
    children: [
      //{ path: '', redirectTo: 'dashboard',pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard] },
      { path: 'cards', loadChildren: './cards/cards.module#CardsModule', canActivate: [AuthGuard] },
      { path: 'elements', loadChildren: './elements/elements.module#ElementsModule', canActivate: [AuthGuard] },
      { path: 'layouts', loadChildren: './layouts/layouts.module#LayoutsModule', canActivate: [AuthGuard] },
      { path: 'forms', loadChildren: './forms/forms.module#FormsModule', canActivate: [AuthGuard] },
      { path: 'tables', loadChildren: './tables/tables.module#TablesModule', canActivate: [AuthGuard] },
      { path: 'pages', loadChildren: './pages/pages.module#PagesModule', canActivate: [AuthGuard] },
      { path: 'uploader', loadChildren: './uploader/uploader.module#UploaderModule', canActivate: [AuthGuard] },
      { path: 'manufacturers', loadChildren: './manufacturers/manufacturers.module#ManufacturersModule', canActivate: [AuthGuard] },
      { path: 'dealers', loadChildren: './dealers/dealers.module#DealersModule', canActivate: [AuthGuard] },
      { path: 'products', loadChildren: './products/products.module#ProductsModule', canActivate: [AuthGuard] },
      { path: 'orders', loadChildren: './orders/orders.module#OrdersModule', canActivate: [AuthGuard] },
      { path: 'configurations', loadChildren: './configurations/configurations.module#ConfigurationsModule', canActivate: [AdminGuard] },
      { path: 'admin', loadChildren: './admin/admin-routing.module#AdminRoutingModule', canActivate: [AdminGuard] },
      { path: 'dealers-portal', loadChildren: './dealers-portal/dealers-portal.module#DealersPortalModule', canActivate: [DealersGuard] },
      { path: 'dealers-portal/products', loadChildren: './products/products.module#ProductsModule', canActivate: [DealersGuard] },
      { path: 'dealers-portal/orders', loadChildren: './orders/orders.module#OrdersModule', canActivate: [DealersGuard] },
      { path: 'business', loadChildren: './business/business.module#BusinessModule', canActivate: [DealersGuard] }
    ]
  },

  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'lock', component: LockComponent },
  { path: 'recover', component: RecoverComponent },
  { path: 'orderconfirmation/:id', component: OrderconfirmationComponent },
  { path: 'account', loadChildren: './account/account.module#AccountModule'},

// Not found
{ path: '**', redirectTo: 'login' }

];



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/routes.ts